/* eslint-disable no-console */
export enum LogLevel {
  None = 0,
  Info = 1,
  Verbose = 2,
  Warn = 3,
  Error = 4,
}

class Logger {
  /**
   * Logs a message as error
   *
   * @param {unknown[]} msg The message to be logged
   */
  public error(...msg: unknown[]): void {
    this.logWith(LogLevel.Error, msg);
  }

  /**
   * Logs a message as info
   *
   * @param {unknown[]} msg The message to be logged
   */
  public info(...msg: unknown[]): void {
    this.logWith(LogLevel.Info, msg);
  }

  /**
   * Logs a message as info
   *
   * @param {unknown[]} msg The message to be logged
   */
  public log(...msg: unknown[]): void {
    this.logWith(LogLevel.None, msg);
  }

  /**
   * Logs a message as a specified level
   *
   * @param {LogLevel} level The level at which to log the message
   * @param {unknown[]} msg The message to be logged
   */
  public logWith(level: LogLevel, msg: unknown[]): void {
    const isDevelopment = import.meta.env.MODE === 'development';
    if (level <= LogLevel.Error) {
      switch (level) {
        case LogLevel.None: {
          if (isDevelopment) {
            console.log(...msg);
          }
          return;
        }
        case LogLevel.Info: {
          if (isDevelopment) {
            console.info(...msg);
          }
          return;
        }
        case LogLevel.Warn: {
          if (isDevelopment) {
            console.warn(...msg);
          }
          return;
        }
        case LogLevel.Error: {
          console.error(...msg);
          return;
        }
        default:
          if (isDevelopment) {
            console.debug(...msg);
          }
      }
    }
  }

  /**
   * Logs the input message as warning
   *
   * @param {unknown[]} msg The message
   */
  public warn(...msg: unknown[]): void {
    this.logWith(LogLevel.Warn, msg);
  }
}

export const useLogger = (): Logger => {
  return new Logger();
};
